import { render, staticRenderFns } from "./foodsuggestiondetails.vue?vue&type=template&id=a6293ea0"
import script from "./foodsuggestiondetails.vue?vue&type=script&lang=js"
export * from "./foodsuggestiondetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports